import appGlobalScript from '/opt/carpentry/src/global.ts';
export const globalScripts = appGlobalScript;
export const globalStyles = "";
